import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import "./v-pills.component.scss";

export interface IPill<T> {
    label: string;
    icon?: string;
    data?: T;
    status?: 'error' | 'warning' | 'success';

    hovering?: boolean;
    tooltip?: string;
}

@Component({
    selector: "v-pills",
    template: require("./v-pills.component.html")
})
export class VPillsComponent {

    @Input() pills: IPill<any>[];
    @Output() pillRemoveClick = new EventEmitter<IPill<any>>();

    @Input() allowRemove: boolean;

    @Input() tooltip?: string;
    hovering: boolean;
    readonly removeIcon: string = "close";

    constructor() { }

    onClickedRemovePill(pill: IPill<any>): void {
        if (!this.allowRemove) {
            return;
        }

        this.pillRemoveClick.emit(pill);
    }

    onMouseEnter(pill: IPill<any>): void {
        pill.hovering = true;
    }

    onMouseLeave(pill: IPill<any>): void {
        pill.hovering = false;
    }
}
